import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface LandingNavProps {
  /** Extra nav links to render alongside defaults */
  extraLinks?: { label: string; href: string }[];
}

const LandingNav = ({ extraLinks }: LandingNavProps) => {
  const { pathname } = useLocation();
  return (
    <nav className="sticky top-0 z-50 border-b border-border bg-background/80 backdrop-blur-md">
      <div className="container mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img
            src="/Unranked-agency-logo.png"
            alt="Unranked Agency"
            className="h-5 sm:h-6 w-auto object-contain max-w-[140px] sm:max-w-none"
          />
        </Link>

        <div className="hidden md:flex items-center gap-8 text-sm text-muted-foreground">
          <Link to="/#how-it-works" className="hover:text-foreground transition-colors">How It Works</Link>
          <Link to="/#features" className="hover:text-foreground transition-colors">Features</Link>
          <Link to="/#faq" className="hover:text-foreground transition-colors">FAQ</Link>
          {pathname !== "/pricing" && <Link to="/pricing" className="hover:text-foreground transition-colors">Pricing</Link>}
          {extraLinks?.map((l) => (
            <Link key={l.href} to={l.href} className="hover:text-foreground transition-colors">
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <Button size="sm" variant="ghost" asChild>
            <Link to="/login">Login</Link>
          </Button>
          <Button size="sm" asChild>
            <Link to="/pricing">
              Get Started
              <ArrowRight className="w-3.5 h-3.5 ml-1" />
            </Link>
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default LandingNav;
